import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import PWABottomNav from '../components/pwa/PWABottomNav';
import PWAHeader from '../components/pwa/PWAHeader';

const PWAContainer = styled.div`
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-bottom: 80px; /* Space for bottom nav */
  width: 100%;
  max-width: 100%;
  padding-top: 0; /* Header is sticky, no padding needed */
  
  /* Desktop PWA size constraint - Phone emulator style */
  @media (min-width: 768px) {
    max-width: 414px !important;
    width: 414px !important;
    margin: 0 auto;
    box-shadow: 0 0 40px rgba(0, 0, 0, 0.8), 
                0 0 0 12px rgba(0, 0, 0, 0.5),
                0 0 0 16px rgba(168, 85, 247, 0.15);
    min-height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    border-radius: 24px;
    position: relative;
    z-index: 1;
    
    /* Center the phone frame */
    left: 50%;
    transform: translateX(-50%);
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  width: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;

const PWALayout: React.FC = () => {
  useEffect(() => {
    // Add desktop PWA mode class to body and html for styling
    if (window.innerWidth >= 768) {
      document.body.classList.add('pwa-desktop-mode');
      document.documentElement.classList.add('pwa-desktop-mode');
    }

    // Handle window resize
    const handleResize = () => {
      if (window.innerWidth >= 768 && window.location.pathname.startsWith('/pwa')) {
        document.body.classList.add('pwa-desktop-mode');
        document.documentElement.classList.add('pwa-desktop-mode');
      } else {
        document.body.classList.remove('pwa-desktop-mode');
        document.documentElement.classList.remove('pwa-desktop-mode');
      }
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      // Always remove class when component unmounts (leaving PWA routes)
      document.body.classList.remove('pwa-desktop-mode');
      document.documentElement.classList.remove('pwa-desktop-mode');
    };
  }, []);

  return (
    <PWAContainer>
      <PWAHeader />
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
      <PWABottomNav />
    </PWAContainer>
  );
};

export default PWALayout;

